import { useEffect, useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_PASSES } from "../../../api/apiRoutes";
import { AssortGroup } from "../../../models/AssortGroup";

interface UsePassesReturn {
  passes: AssortGroup[];
  loading: boolean;
  selectedDate: Date;
  setDateBetween: (date: Date) => void;
}

const usePasses = (additionalRequestParams?: any): UsePassesReturn => {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [passes, setPasses] = useState<AssortGroup[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  const setDateBetween = async (date: Date) => {
    setSelectedDate(date);
  };

  const requestGetAssortGroups = async () => {
    setLoading(true);
    const { result, isError } = await get(
      GET_PASSES(
        facilityIds,
        additionalRequestParams?.colorIds,
        additionalRequestParams?.shapeIds,
        additionalRequestParams?.assortGroupIds,
        additionalRequestParams?.assortIds
      )
    );
    if (!isError) {
      setPasses(result);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (Boolean(facilityIds)) {
      requestGetAssortGroups();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return {
    passes,
    setDateBetween,
    selectedDate,
    loading,
  };
};

export default usePasses;
